<template>
  <div>
    <div class="wrap coach-recom-wrap pb-30">
      <div class="top-header">
        <incBack></incBack>
        <h3>예약하기</h3>
      </div>
      <div class="body-wrap">
        <div class="recomm">
          <h4>
            나에게 딱 맞는<br />
            <span class="bold">코치 추천! </span>
          </h4>
          <div class="coach-slide">
            <div>
              <div v-if="isLoading">
                <VueSlickCarousel v-if="coachs.length" v-bind="settings">
                  <div v-for="(item, index) in coachs" :key="index" @click="pushCoachDetailPage(item.coarIdx)" class="coach-card">
                    <div class="clear profile">
                      <img src="@/assets/img/coach_bg.png" class="bg" />
                      <img :src="item.coarPic" class="profile-img" alt="코치 이미지" style="width: 100%" />
                    </div>
                    <div class="info">
                      <h1>{{ item.userName }} <span>코치</span></h1>
                      <p>{{ item.coarOnelineIntroduction }}</p>
                    </div>
                  </div>
                </VueSlickCarousel>
              </div>
            </div>
          </div>
        </div>
        <div class="side">
          <!-- 재추천 받기가 Y 이면서, 재추천 받기를 한번도 누르지 않은 상태에서만 나옴-->
          <div
            style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column"
            v-if="reRecommendWhether && $store.state.isReRecom == '0'"
          >
            <h2>비슷한 성향의 코치들은 어떠신가요?</h2>
            <p @click="getReRecommendCoachs()">재추천 받기</p>
          </div>
          <!-- 재추천 받기를 1번이라도 눌렀을 때, 나옴 -->
          <p
            style="width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column"
            v-if="$store.state.isReRecom == '1'"
          >
            <span @click="getBeforeRecommendCoachs()" class="mr-20">이전 코치 추천 보기</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "start_coach_recom",
  props: {
    rebook: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    settings: {
      dots: false,
      infinite: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
    },
    coachs: [],
    reRecommendWhether: false,
    isLoading: false,
  }),
  components: {
    VueSlickCarousel,
    incBack,
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.getRecommendCoachs();
    },

    // 최초 List 를 가져오는 Method
    async getRecommendCoachs() {
      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,

        // 해당 키는 coach_view Page 를 넘어갔을 때, 사용 하는 store state
        // 1이면 기존 Data 가져오기
        // 0이면 새로운 List 가져오기
        // 해당 키가 detail page 에서, back 을 이용하여 recommend 페이지로 넘어 왔을 때, 기존 Data 를 그대로 보여주기 위한 용도
        // 따라서 해당 state 를 바꾸는 경우는 다음과 같음.
        // -- reserve가 완료 되었을 때, 0으로 변경
        // -- reserve subject page 에서 0 으로 변경
        // -- coach detail page 를 넘어갔을때, 1로 변경
        // pagefunc: this.$store.state.pageFunc,
      };

      const result = await this.axios.get("/front/user/recommendCoarch/list", { params });

      if (result.data.success) {
        if (result.data.contentinfo.recommendList.length === 0) {
          const result = await this.axios.get("/front/user/recommendCoarch/last", { params });

          if (result.data.success) {
            this.coachs = result.data.data;
            this.reRecommendWhether = false;
          }
        } else {
          this.reRecommendWhether = result.data.contentinfo.reRecommendYN === "Y" ? true : false;
          this.coachs = result.data.contentinfo.recommendList;
        }
      }
      this.isLoading = true;
    },

    // 최초 호출 이후, 재추천 받기를 눌렀을 때 동작하는 Method
    async getReRecommendCoachs() {
      this.isLoading = false;

      let params = {
        courseIdx: this.$store.state.userInfo.courseIdx,
        userIdx: this.$store.state.userInfo.userIdx,
        pagefunc: "0",
      };

      const result = await this.axios.get("/front/user/recommendCoarch/relist", { params });
      if (result.data.success) {
        this.coachs = result.data.data;
        // ** struct 가 아직 잡히지 않아서, 기존 code 사용
        // this.reRecommendWhether = result.data.contentinfo.reRecommendYN === "Y" ? true : false;
        // this.coachs = result.data.contentinfo.recommendList;
        this.$store.commit("setIsReRcom", "1");
        this.isLoading = true;
      }

      // 재추천 받기를 눌렀는지 확인하는 코드
      // 1 은 눌렀음
      // 0 은 누르지 않음.
      // 재추천 받기를 눌렀다고 간주
      // 추후 개발이 필요하다면, 해당 component 구성을 모달로 변경하는 작업이 필요함.
    },

    // 이전 코치 보기 눌렀을 때 동작하는 Method
    async getBeforeRecommendCoachs() {
      this.isLoading = false;

      let params = {
        userIdx: this.$store.state.userInfo.userIdx,
        courseIdx: this.$store.state.userInfo.courseIdx,
      };

      const result = await this.axios.get("/front/user/recommendCoarch/already", { params });

      if (result.data.success) {
        this.coachs = result.data.data;
        // ** struct 가 아직 잡히지 않아서, 기존 code 사용
        // this.reRecommendWhether = result.data.contentinfo.reRecommendYN === "Y" ? true : false;
        // this.coachs = result.data.contentinfo.recommendList;
      }

      // 재추천 받기를 눌렀는지 확인하는 코드
      // 1 은 눌렀음
      // 0 은 누르지 않음.
      // 이전 추천 코치 보기를 누르면, 재추천 받기를 누르지 않은 상태와 같아, 재추천 받기를 누르지 않은 상태로 간주
      // 추후 개발이 필요하다면, 해당 component 구성을 모달로 변경하는 작업이 필요함.
      this.$store.commit("setIsReRcom", "0");

      this.isLoading = true;
    },

    pushCoachDetailPage(idx) {
      this.$router.push({ name: "coach_view", params: { idx: idx, rebook: this.rebook } });
      this.$store.commit("setpageFunc", "1");
    },
  },
};
</script>
